
















import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component
export default class VerDetalleModalTab extends Vue {
  @Prop({ default: '' }) unidadVehiculo: string;

  dialog = true;

  handleCerrar() {
    this.$emit('cerrar');
  }
}
